import { Flex, Box } from '@chakra-ui/layout';
import { UnfilledError } from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import ALI from 'models/Forms/ALI';
import React, { memo, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ALICtx } from '../..';
import { getALIFinishPosition } from 'services/ALIConclusion';
import { useParams } from 'react-router-dom';

const okimg = require('assets/images/circle-check.svg').default;
const cancelimg = require('assets/images/circle-xmark.svg').default;

const Img = styled.img`
  display: flex;
  justify-content: 'center';
  align-items: center;
  height: 80px;
  width: 80px;
  margin: 0;
`;

const Text = styled.p`
  margin: auto 10px;
`;

interface IProps extends BodyProps {
  dataDetail?: ALI;
  unfilledSteps: string[];
  isDone?: boolean;
}

interface IParams {
  id: string;
}

const Item: React.FC<IProps> = ({ unfilledSteps }) => {
  const params = useParams<IParams>();
  const ctx = useContext(ALICtx);
  const { load } = ctx;
  // const { load, setIsLoad } = useContext(ALICtx);

  const [unfilledStepRef, setUnfilledStepRef] = useState<string[]>([]);

  const unfilled: number[] = [1, 2, 3, 4, 5, 6];

  const unfilledStep: string[] = [
    '1 - Conceitos relevantes e descrição da atividade',
    '2 - Dados sensíveis',
    '3 - Finalidade concreta',
    '4 - Licitude',
    '5 - Necessidade',
    '6 - Transparência',
  ];
  // eslint-disable-next-line prefer-const
  let unfilledStepsRef: string[] = [];

  const getFormConclusions = async (finishForm: number) => {
    const id = Number(params.id);
    const response = await getALIFinishPosition(finishForm, id);

    if (!response.data) {
      if (unfilledStep[finishForm - 1][0] === String(finishForm)) {
        unfilledStepsRef.push(unfilledStep[finishForm - 1]);
      }
    } else {
      const index = unfilledStepsRef.indexOf(unfilledStep[finishForm - 1]);
      if (index > -1) unfilledStepsRef.splice(index, 1);
    }
    setUnfilledStepRef([...unfilledStepsRef]);
  };

  useEffect(() => {
    // (() => {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!params.id && !load) {
      if (
        (ctx.data.status === 'DONE' &&
          (unfilledSteps.length !== 0 || unfilledStepsRef.length !== 0)) ||
        ctx.data.status === 'DRAFT'
      ) {
        unfilled.forEach(item => {
          getFormConclusions(item);
        });
      }
    }
    // })();
  }, [load]);

  // eslint-disable-next-line no-extra-boolean-cast
  if (!!params.id) {
    if (unfilledStepRef.length > 0) {
      return <UnfilledError unfilledSteps={unfilledStepRef.sort()} />;
    }
  }

  if (unfilledStepRef.length === 0) {
    if (params.id) {
      return (
        <Flex width="100%">
          <Box display="flex" mx="140px">
            {ctx.results?.conclusion.risk.message === 'NÃO' && (
              <Box display="flex" border="1px solid" borderColor="brand.red100" borderRadius="4px">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flex="0 0 80px"
                  backgroundColor="brand.red100"
                >
                  <Img src={cancelimg} alt="logo" />
                </Box>
                <Box display="flex">
                  <Text>
                    <b>Não:</b> Sua atividade não reúne elementos que a enquadram na base legal do
                    legítimo interesse.
                  </Text>
                </Box>
              </Box>
            )}
            {ctx.results?.conclusion.risk.message === 'SIM' && (
              <Box
                display="flex"
                border="1px solid"
                borderColor="brand.green100"
                borderRadius="4px"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flex="0 0 80px"
                  backgroundColor="brand.green100"
                >
                  <Img src={okimg} />
                </Box>
                <Box display="flex">
                  <Text>
                    <b>SIM:</b> Sua atividade reúne elementos que a enquadram na base legal do
                    legítimo interesse.
                  </Text>
                </Box>
              </Box>
            )}
          </Box>
        </Flex>
      );
    }
  }

  if (unfilledSteps.length > 0) {
    return <UnfilledError unfilledSteps={unfilledSteps} />;
  }
  return (
    <Flex width="100%">
      <Box display="flex" mx="140px">
        {ctx.results?.conclusion.risk.message === 'NÃO' && (
          <Box display="flex" border="1px solid" borderColor="brand.red100" borderRadius="4px">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flex="0 0 80px"
              backgroundColor="brand.red100"
            >
              <Img src={cancelimg} alt="logo" />
            </Box>
            <Box display="flex">
              <Text>
                <b>Não:</b> Sua atividade não reúne elementos que a enquadram na base legal do
                legítimo interesse.
              </Text>
            </Box>
          </Box>
        )}
        {ctx.results?.conclusion.risk.message === 'SIM' && (
          <Box display="flex" border="1px solid" borderColor="brand.green100" borderRadius="4px">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flex="0 0 80px"
              backgroundColor="brand.green100"
            >
              <Img src={okimg} />
            </Box>
            <Box display="flex">
              <Text>
                <b>SIM:</b> Sua atividade reúne elementos que a enquadram na base legal do legítimo
                interesse.
              </Text>
            </Box>
          </Box>
        )}
      </Box>
    </Flex>
  );
};

export const Conclusions = memo(Item);
